<template>
  <div
    class="twofa-sent d-flex flex-column justify-content-center align-items-center"
  >
    <div class="logo">
      <img
        src="@/assets/images/bloom_logo.svg"
        alt="logo"
        class="img-fluid"
      />
    </div>
    <div class="message-container">
      <p>
        ご登録のメールアドレスへ本人認証用リンクを送信しました。<br />
        メール内から本人認証を完了してください。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFASent',
  mounted() {
    this.changeBodyToWhite();
  },
};
</script>

<style scoped>
.message-container {
  margin-top: 100px;
  background-color: #d4edda;
  color: #155724;
  padding: 10px;
  width: 471px;
  margin: 50px auto;
  height: 100px;
  font-size: 14px;
  text-align: left;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.twofa-sent {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  text-align: center;
}

.img-fluid {
  width: 300px;
  height: auto;
}
p {
  margin: 0 !important;
}
</style>
